/**
 * Focus that means the user is still working in a table list: keyboard focus,
 * or a text box they're typing in. A click leaves focus on the clicked row,
 * and that alone doesn't count.
 */
export function isWorkingFocus(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  try {
    return target.matches(':focus-visible')
  } catch {
    return target instanceof HTMLInputElement
  }
}
